module.exports = __webpack_public_path__ + "img/kanban06.c96a5af4.png";